import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiServiceProvider } from "../../providers/api-service/api-service";
import { MyApp } from "../../app/app.component";
import { NavController, AlertController } from "ionic-angular";
import { AppSettings } from "../../services/app-settings";

@Injectable()
export class UserServiceProvider {
  GetSiteBackground(): any {
    var projectName = MyApp.CB_PLATFORM;
    return AppSettings[projectName].PAGE_BACKGROUND;
  }

  GetHomePageTitle(): any {
    var projectName = MyApp.CB_PLATFORM;
    return AppSettings[projectName].HOMEPAGE_TITLE;
  }

  GetSiteLogo() {
    var projectName = MyApp.CB_PLATFORM;
    return AppSettings[projectName].LOGIN_LOGO;
  }

  GetTargetURLForCurrentProject() {
    var projectName = MyApp.CB_PLATFORM;
    return AppSettings[projectName].WEB_URL;
  }

  GetMenuForApp(CB_PLATFORM: string): any[] {
    if (CB_PLATFORM == "LP") return this.constructMenuForLP();
    else if (CB_PLATFORM == "ZOO") return this.constructMenuForZoo();
    else return this.constructMenuForGeneralPOS();
  }

  public userName: string = "";
  public password: string = "";
  public AuthenticationFailed = false;

  constructMenuForLP() {
    if (this.getUserType() == "STAFF") {
      return [
        {
          title: "Home",
          icon: "icon-home-modern",
          navPath: "Cb001HomepagePage"
        },
        {
          title: "Nhiệm Vụ Giao Hàng",
          icon: "icon-ticket-account",
          navPath: "DeliveryTaskPage"
        },
        {
          title: "ĐH giao không thành công",
          icon: "icon-monitor",
          navPath: "DeliveryTransactionMissedPage"
        },
        {
          title: "Theo Dõi Công Nợ",
          icon: "icon-cash",
          navPath: "MonitoringDebtPage"
        },
        //{ "title": "News", "icon": "icon-newspaper",  "navPath": "Acom001NewsPage", },
        {
          title: "Đổi mật khẩu",
          icon: "icon-account",
          navPath: "ChangePasswordPage"
        }
        // { "title": "GPS Tracking", "icon": "icon-compass",  "navPath": "Acom020GpsTrackingPage", },
        // { "title": "Advance SMS", "icon": "icon-message-reply", "navPath": "Acom005CiibosSmsPage", },
        // { "title": "Text To Speak", "icon": "icon-speaker",  "navPath": "Acom025TextToSpeechPage", },
        // { "title": "Barcode Scanner", "icon": "icon-barcode", "navPath": "BarcodePage", },
      ];
    } else if (this.getUserType() == "CONTACT") {
      return [
        {
          title: "Home",
          icon: "icon-home-modern",
          navPath: "Cb001HomepagePage"
        },
        {
          title: "Tạo Đơn Hàng",
          icon: " icon-plus",
          navPath: "DeliveryRequestPage"
        },
        {
          title: "Xem Đơn Hàng",
          icon: "icon-view-list",
          navPath: "DeliveryRequestViewPage"
        },
        {
          title: "Theo Dõi ĐH Công Nợ",
          icon: "icon-book-multiple",
          navPath: "DeliveryRequestDebitViewPage"
        },
        {
          title: "ĐH giao không thành công",
          icon: "icon-close-circle-outline",
          navPath: "DeliveryTransactionMissedPage"
        },
        {
          title: "Theo Dõi Công Nợ LP",
          icon: "icon-book-multiple",
          navPath: "MonitoringDebtPage"
        },
        {
          title: "Công Nợ KHC",
          icon: "icon-checkbox-multiple-marked-outline",
          navPath: "AccountMonitoringDebtPage"
        },
        // { "title": "Quản Lý KH Cuối", "icon": "icon-view-list",  "navPath": "ViewContactListPage", },
        //{ "title": "News", "icon": "icon-newspaper",  "navPath": "Acom001NewsPage", },
        {
          title: "Đổi mật khẩu",
          icon: "icon-key-change",
          navPath: "ChangePasswordPage"
        }
      ];
    } else {
      alert("section invalid");
      this.logout();
    }
  }
  constructMenuForZoo() {
    if (this.getUserType() == "STAFF") {
      return [
        {
          title: "Home",
          icon: "icon-home-modern",
          navPath: "Cb001HomepagePage"
        },
        {
          title: "Bán vé cổng ",
          icon: "icon-home-modern",
          navPath: "Pos021PosTicketPage"
        },
        {
          title: "Bán vé oto/Xe L/Đ ",
          icon: "icon-home-modern",
          navPath: "Pos032GeneralticketPage"
        },
        {
          title: "Bán vé trò chơi ",
          icon: "icon-home-modern",
          navPath: "Pos030GamesticketPage"
        },

        {
          title: "Thống kê tổng vé/hàng bán",
          icon: "icon-home-modern",
          navPath: "Pos350TickettransactionPage"
        },
        // {
        //   title: "Thống kê theo nhân viên",
        //   icon: "icon-home-modern",
        //   navPath: "Pos351TickettransactionByUserPage"
        // },

        {
          title: "Thống kê lịch sử giao dịch",
          icon: "icon-home-modern",
          navPath: "Pos016TablesTransactionsPage"
        },

        // { "title": "Waiter Main"        , "icon": "icon-home-modern"      ,  "navPath": "Pos008WaiterScreenPage", },
        // { "title": "Client Order Transaction"        , "icon": "icon-home-modern"      ,  "navPath": "Pos300ClientOrderTransactionPage", },
        // { "title": "Client Order Tracking"        , "icon": "icon-home-modern"      ,  "navPath": "Pos305ClientOrderTrackingPage", },
        {
          title: "Dịch vụ ăn uống",
          icon: "icon-home-modern",
          navPath: "Pos008WaiterScreenPage"
        },
        {
          title: "Thức ăn đồ uống nhanh",
          icon: "icon-home-modern",
          navPath: "Pos033FastOrderServicePage"
        },
        {
          title: "Thống kê ẩm thực",
          icon: "icon-home-modern",
          navPath: "Pos360FoodTransactionPage"
        },
        {
          title: "Duyệt Web Orders",
          icon: "icon-home-modern",
          navPath: "Woo001ApproveWebOrdersPage"
        },
        {
          title: "Duyệt đề nghị chi",
          icon: "icon-home-modern",
          navPath: "Act100PaymentRequestListPage"
        },
        {
          title: "Duyệt đề nghị mua hàng",
          icon: "icon-home-modern",
          navPath: "Act101PurchasingRequestListPage"
        },
        {
          title: "Duyệt đề nghị thanh toán tạm ứng",
          icon: "icon-home-modern",
          navPath: "Act102AdvanceRequestListPage"
        },
        {
          title: "E-Commerce",
          icon: "icon-newspaper",
          navPath: "Acom001NewsPage"
        },
        // { "title": "Test Máy In"        , "icon": "icon-home-modern"      ,  "navPath": "Acom000SystemSettingsPage", },

        // { "title": "Tạo Order", "icon": "icon-compass",  "navPath": "Pos020PosOrderPage", },
        // { "title": "Quản lý bàn", "icon": "icon-compass",  "navPath": "Pos005TablelistPage", },
        // { "title": "Danh mục sản phẩm", "icon": "icon-compass",  "navPath": "Pos009CategorylistPage", },
        // { "title": "Danh sách sản phẩm", "icon": "icon-compass",  "navPath": "Pos010ProductlistPage", },
        // { "title": "Danh sách động vật", "icon": "icon-compass",  "navPath": "Tcv008AnimalCategoriesPage", },
        // { "title": "GPS Tracking", "icon": "icon-compass",  "navPath": "Acom020GpsTrackingPage", },
        // { "title": "Fingerprint Reader", "icon": "icon-readability", "navPath": "Acom009CiibosAdvanceLocationPage", },
        // { "title": "Advance SMS", "icon": "icon-message-reply", "navPath": "Acom005CiibosSmsPage", },
        // { "title": "Text To Speak", "icon": "icon-speaker",  "navPath": "Acom025TextToSpeechPage", },
        // { "title": "SuperDashboard", "icon": "icon-view-dashboard",  "navPath": "Adab_010SaleRevenuesPage", },
        {
          title: "Barcode Scanner",
          icon: "icon-barcode",
          navPath: "Com100BarcodeScannerPage"
        },
        {
          title: "Đổi mật khẩu",
          icon: "icon-account",
          navPath: "ChangePasswordPage"
        }
      ];
    } else if (this.getUserType() == "CONTACT") {
      return [
        {
          title: "Home",
          icon: "icon-home-modern",
          navPath: "Cb001HomepagePage"
        },
        {
          title: "Tạo Đơn Hàng",
          icon: " icon-plus",
          navPath: "DeliveryRequestPage"
        },
        {
          title: "Xem Đơn Hàng",
          icon: "icon-view-list",
          navPath: "DeliveryRequestViewPage"
        },
        {
          title: "Theo Dõi ĐH Công Nợ",
          icon: "icon-book-multiple",
          navPath: "DeliveryRequestDebitViewPage"
        },
        {
          title: "Theo dõi ĐH chưa giao",
          icon: "icon-close-circle-outline",
          navPath: "DeliveryTransactionMissedPage"
        },
        {
          title: "Theo Dõi Công Nợ LP",
          icon: "icon-book-multiple",
          navPath: "MonitoringDebtPage"
        },
        {
          title: "Công Nợ KHC",
          icon: "icon-checkbox-multiple-marked-outline",
          navPath: "AccountMonitoringDebtPage"
        },
        { title: "News", icon: "icon-newspaper", navPath: "Acom001NewsPage" },
        {
          title: "Đổi mật khẩu",
          icon: "icon-key-change",
          navPath: "ChangePasswordPage"
        }
      ];
    } 
    else {
      console.log("section invalid");
      this.logout();
    }
  }
  constructMenuForGeneralPOS() {
    if (this.getUserType() == "STAFF") {
      return [
        {
          title: "Trang chủ",
          icon: "icon-home-modern",
          navPath: "Cb001HomepagePage"
        },

        {
          title: "Thống kê tổng vé/hàng bán",
          icon: "icon-home-modern",
          navPath: "Pos350TickettransactionPage"
        },


        {
          title: "Thống kê lịch sử giao dịch",
          icon: "icon-home-modern",
          navPath: "Pos016TablesTransactionsPage"
        },
      ];
    } else if (this.getUserType() == "CONTACT") {
      return [
        {
          title: "Home",
          icon: "icon-home-modern",
          navPath: "Cb001HomepagePage"
        },
        {
          title: "Tạo Đơn Hàng",
          icon: " icon-plus",
          navPath: "DeliveryRequestPage"
        },
        {
          title: "Xem Đơn Hàng",
          icon: "icon-view-list",
          navPath: "DeliveryRequestViewPage"
        },
        {
          title: "Theo Dõi ĐH Công Nợ",
          icon: "icon-book-multiple",
          navPath: "DeliveryRequestDebitViewPage"
        },
        {
          title: "Theo dõi ĐH chưa giao",
          icon: "icon-close-circle-outline",
          navPath: "DeliveryTransactionMissedPage"
        },
        {
          title: "Theo Dõi Công Nợ LP",
          icon: "icon-book-multiple",
          navPath: "MonitoringDebtPage"
        },
        {
          title: "Công Nợ KHC",
          icon: "icon-checkbox-multiple-marked-outline",
          navPath: "AccountMonitoringDebtPage"
        },
        { title: "News", icon: "icon-newspaper", navPath: "Acom001NewsPage" },
        {
          title: "Đổi mật khẩu",
          icon: "icon-key-change",
          navPath: "ChangePasswordPage"
        }
      ];
    } else {
      console.log("section invalid");
      this.logout();
    }
  }

  changePassword(pOldPass,newPassword) {
    return this.apiService.post(this.apiService.api.user_change_password, {
      user_id: this.getUserId(),
      user_type: this.getUserType(),
      old_password : pOldPass,
      new_password: newPassword
    });
  }

  getPassword() {
    return this.apiService.post(this.apiService.api.user_get_password, {
      user_id: this.getUserId(),
      user_type: this.getUserType()
    });
  }

  constructor(
    public http: HttpClient,
    public apiService: ApiServiceProvider,
    public alertCtrl: AlertController
  ) {
    // this.cb_user =   MyApp.getInstance().user ;
  }

  async processLogin(pUserName: string, pPassword: string) {
    let params = {
      user_name: pUserName,
      password: pPassword
    };

    var user_data: any = {};
    user_data = await this.apiService.get("gencb/login", params);



    if (user_data.data_staff == null || !user_data.data_staff) {
      this.AuthenticationFailed = true;
      return false;
    }

    if (user_data.info == 1) {
      this.AuthenticationFailed = null;

      MyApp.getInstance().cb_user.is_logged = true;
      MyApp.getInstance().cb_user.user_id = user_data.data_staff[0].USER_ID;
      MyApp.getInstance().cb_user.full_name = user_data.data_staff[0].FULL_NAME;
      MyApp.getInstance().cb_user.user_type = user_data.data_staff[0].USER_TYPE;
      MyApp.getInstance().cb_user.token = user_data.token;

      window.localStorage.setItem(
        "cb_user",
        JSON.stringify(MyApp.getInstance().cb_user)
      );
      //MyApp.getInstance().constructMainMenu();      
      return true;
    }
    else {
      alert("Authentication failed");
      this.AuthenticationFailed = true;
      return false;
    }
  }

  showLoginFail() {
    const alert = this.alertCtrl.create({
      title: "Login fail",
      subTitle: "Incorrect username and password",
      buttons: ["OK"]
    });
    alert.present();
  }

  authentication() {
    console.log(
      " ============================ Authenticate me again =================== "
    );
    console.log(window.localStorage.getItem("cb_user"));
    return this.apiService.post(this.apiService.api.auth);
  }

  getUser() {
    return MyApp.getInstance().cb_user;
  }

  isAuth() {
    return MyApp.getInstance().cb_user.is_logged;
  }

  getUserId() {
      return MyApp.getInstance().cb_user.user_id;

  }

  getUserType() {
    return MyApp.getInstance().cb_user.user_type;
  }

  getDummyStaffId() {
    return MyApp.getInstance().cb_user.dummy_staff;
  }

  logout() {
    
    //console.log(MyApp.getInstance().cb_user);
    MyApp.getInstance().cb_user.is_logged = false;
    MyApp.getInstance().cb_user.user_id = -1;
    MyApp.getInstance().cb_user.full_name = "";
    MyApp.getInstance().cb_user.user_type = "";
    MyApp.getInstance().cb_user.token = "";
    window.localStorage.setItem("cb_user", "");
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-service/user-service.ts